import styled from 'styled-components';

export const EditorHeader = styled.div`
  display: flex;
  column-gap: 10px;
  justify-content: space-between;

  & input {
    flex-grow: 2;
  }
`;

export const EditorHeaderContainer = styled.div`
  min-height: 350px;
  padding: 25px 20px 20px 20px;
`;
